import React from "react";
import { Heart, Compass, HandHeart } from "lucide-react";

const values = [
  {
    icon: Heart,
    title: "Emotionally Grounded",
    text: "Honest conversation that meets you in the real seasons of life.",
  },
  {
    icon: Compass,
    title: "Practical Hope",
    text: "Encouragement you can actually carry into Monday — not just Sunday.",
  },
  {
    icon: HandHeart,
    title: "Trustworthy Care",
    text: "Years of chaplaincy walking alongside grief, caregiving, and stress.",
  },
];

const About = () => {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="py-20 lg:py-28 bg-white"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
          <div className="lg:col-span-5 relative">
            <div className="absolute -inset-3 rounded-[2rem] bg-amber-50/60" aria-hidden />
            <img
              src="https://images.unsplash.com/photo-1731395157985-76af28b68afa?crop=entropy&cs=srgb&fm=jpg&q=85&w=1000"
              alt="Chaplain Derrick speaking warmly to an audience"
              className="relative rounded-[1.75rem] w-full h-[520px] object-cover"
              data-testid="about-image"
            />
          </div>

          <div className="lg:col-span-7">
            <span className="text-xs uppercase tracking-[0.22em] font-semibold text-[#D97706]">
              About Ask Chaplain Derrick
            </span>
            <h2 className="mt-4 font-heading text-3xl sm:text-4xl lg:text-5xl tracking-tight text-slate-900 leading-tight">
              <span className="gold-underline">A steady voice</span> for life&apos;s
              difficult seasons.
            </h2>
            <p className="mt-6 text-base sm:text-lg leading-relaxed text-slate-600">
              Chaplain Derrick is a teacher, author, and pastoral care provider
              with years of experience walking alongside people in hospitals,
              workplaces, and communities. Through honest conversation and
              lived experience, he offers practical encouragement for grief,
              caregiving, burnout, and the everyday questions most of us carry
              quietly.
            </p>
            <p className="mt-4 text-base sm:text-lg leading-relaxed text-slate-600">
              Spiritual reflection is welcomed here, but never pushed. This
              space is built to feel safe and approachable whether faith is
              part of your story or not — quiet, trustworthy, and human.
            </p>

            <div className="mt-10 grid grid-cols-1 sm:grid-cols-3 gap-4">
              {values.map(({ icon: Icon, title, text }) => (
                <div
                  key={title}
                  data-testid={`about-value-${title.toLowerCase().replace(/\s+/g, "-")}`}
                  className="rounded-2xl border border-slate-100 bg-white p-5 lift"
                >
                  <div className="h-9 w-9 rounded-full bg-[#F0F9FF] text-[#0369A1] flex items-center justify-center">
                    <Icon size={18} />
                  </div>
                  <p className="mt-4 font-heading text-slate-900 text-base">
                    {title}
                  </p>
                  <p className="mt-1 text-sm text-slate-500 leading-relaxed">
                    {text}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
